import React from 'react';

import { makeStyles } from '@material-ui/core';
import { Link } from '@material-ui/core';

const ActionLink = ({ type, onClickFunction, className = '' }) => {
  const useStyles = makeStyles({
    button: {
      marginRight: '10px'
    }
  });

  const classes = useStyles();

  return (
    <Link
      onClick={ onClickFunction }
      color="inherit"
      variant="body2"
      className={ className || classes.button }
    >
      { type }
    </Link>
  );
};

export default ActionLink;
